// // src/pages/.../BatchPrincipalsAndVicePrincipalsView.tsx
// // REPLACE the entire file with this.
// // Adjust the import path for uploadPrincipalsPostingCsv and Navbar/Loader/LogoLoader to match your project.

// import React, { useCallback, useRef, useState } from "react";
// import { toast } from "react-toastify";
// import { Navbar, Loader } from "components";
// import { uploadPrincipalsPostingCsv } from "../../services/schools.service";

// interface RowError {
//   row: number;
//   reason: string;
// }

// interface UploadResult {
//   totalQueued: number;
//   skipped: number;
//   rowErrors: RowError[];
// }

// /** Merge top-level PATCH body with nested DATA / Data / data objects from this API. */
// function flattenResponseData(res: { data?: unknown } | undefined): Record<string, unknown> {
//   const body = res?.data;
//   if (!body || typeof body !== "object" || body === null) return {};
//   const record = body as Record<string, unknown>;
//   const nested = [record.DATA, record.Data, record.data].find(
//     (v): v is Record<string, unknown> => Boolean(v) && typeof v === "object" && !Array.isArray(v)
//   );
//   return nested ? { ...record, ...nested } : record;
// }

// export const BatchPrincipalsAndVicePrincipalsView: React.FC = () => {
//   const [file, setFile] = useState<File | null>(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [result, setResult] = useState<UploadResult | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);

//   const resetSelection = () => {
//     setFile(null);
//     setResult(null);
//     if (fileInputRef.current) fileInputRef.current.value = "";
//   };

//   const validateAndSetFile = (selected: File | undefined | null) => {
//     if (!selected) return;
//     if (!selected.name.toLowerCase().endsWith(".csv")) {
//       toast.error("Please select a .csv file");
//       return;
//     }
//     setFile(selected);
//     setResult(null);
//   };

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     validateAndSetFile(e.target.files?.[0]);
//   };

//   const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     setIsDragging(false);
//     validateAndSetFile(e.dataTransfer.files?.[0]);
//   }, []);

//   const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     setIsDragging(true);
//   };

//   const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
//     e.preventDefault();
//     setIsDragging(false);
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       toast.error("Please select a CSV file to upload.");
//       return;
//     }

//     try {
//       setLoading(true);
//       setResult(null);
//       const response = await uploadPrincipalsPostingCsv(file);
//       const flat = flattenResponseData(response);

//       const totalQueued = typeof flat.totalQueued === "number" ? flat.totalQueued : 0;
//       const skipped = typeof flat.skipped === "number" ? flat.skipped : 0;
//       const rowErrors = Array.isArray(flat.rowErrors) ? (flat.rowErrors as RowError[]) : [];

//       setResult({ totalQueued, skipped, rowErrors });

//       if (totalQueued > 0) {
//         toast.success(`${totalQueued} posting job(s) queued successfully`);
//       } else {
//         toast.warn("No valid records were queued. Check the errors below.");
//       }
//     } catch (error: any) {
//       const apiRowErrors = error?.response?.data?.rowErrors as RowError[] | undefined;
//       const apiMessage = error?.response?.data?.MESSAGE as string | undefined;

//       if (apiRowErrors?.length) {
//         setResult({ totalQueued: 0, skipped: apiRowErrors.length, rowErrors: apiRowErrors });
//       }
//       toast.error(apiMessage ?? (error instanceof Error ? error.message : "Failed to upload CSV."));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="max-w-4xl mx-auto pt-24 px-4 pb-12">
//         <h2 className="text-2xl font-bold mb-6">Batch Post Principals & Vice Principals</h2>

//         <div
//           onDrop={handleDrop}
//           onDragOver={handleDragOver}
//           onDragLeave={handleDragLeave}
//           onClick={() => fileInputRef.current?.click()}
//           className={`border-2 border-dashed rounded-lg p-10 text-center cursor-pointer transition ${
//             isDragging ? "border-indigo-500 bg-indigo-50" : "border-gray-300 bg-gray-50"
//           }`}
//         >
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept=".csv"
//             onChange={handleFileChange}
//             className="hidden"
//           />
//           {file ? (
//             <p className="text-gray-800 font-medium">{file.name}</p>
//           ) : (
//             <p className="text-gray-500">
//               Drag & drop a CSV file here, or click to select one
//             </p>
//           )}
//         </div>

//         <div className="flex justify-end gap-3 mt-6">
//           <button
//             onClick={resetSelection}
//             disabled={!file || loading}
//             className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 disabled:opacity-50"
//           >
//             Clear
//           </button>
//           <button
//             onClick={handleUpload}
//             disabled={!file || loading}
//             className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2"
//           >
//             {loading ? <Loader /> : "Upload & Queue"}
//           </button>
//         </div>

//         {result && (
//           <div className="mt-10">
//             <div className="flex gap-4 mb-4">
//               <div className="flex-1 bg-green-50 border border-green-200 rounded-lg p-4">
//                 <p className="text-sm text-green-700">Queued</p>
//                 <p className="text-2xl font-bold text-green-800">{result.totalQueued}</p>
//               </div>
//               <div className="flex-1 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
//                 <p className="text-sm text-yellow-700">Skipped</p>
//                 <p className="text-2xl font-bold text-yellow-800">{result.skipped}</p>
//               </div>
//             </div>

//             {result.rowErrors.length > 0 && (
//               <div className="border border-gray-200 rounded-lg overflow-hidden">
//                 <table className="w-full text-left text-sm">
//                   <thead className="bg-gray-100">
//                     <tr>
//                       <th className="px-4 py-2 w-20">Row</th>
//                       <th className="px-4 py-2">Reason</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {result.rowErrors.map((rowError, idx) => (
//                       <tr key={`${rowError.row}-${idx}`} className="border-t border-gray-200">
//                         <td className="px-4 py-2">{rowError.row}</td>
//                         <td className="px-4 py-2 text-red-600">{rowError.reason}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };





// src/pages/.../BatchPrincipalsAndVicePrincipalsView.tsx
// FULL FILE — replace entirely

import React, { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Navbar, Loader } from "components";
import { uploadPrincipalsPostingCsv } from "../../services/schools.service";
import { useJobLogs } from "../../hooks/useJobLogs";

interface RowError {
  row: number;
  reason: string;
}

interface UploadResult {
  jobId: string | null;
  totalQueued: number;
  skipped: number;
  rowErrors: RowError[];
}

function flattenResponseData(res: { data?: unknown } | undefined): Record<string, unknown> {
  const body = res?.data;
  if (!body || typeof body !== "object" || body === null) return {};
  const record = body as Record<string, unknown>;
  const nested = [record.DATA, record.Data, record.data].find(
    (v): v is Record<string, unknown> => Boolean(v) && typeof v === "object" && !Array.isArray(v)
  );
  return nested ? { ...record, ...nested } : record;
}

export const BatchPrincipalsAndVicePrincipalsView: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<UploadResult | null>(null);
  const [jobId, setJobId] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const logsEndRef = useRef<HTMLDivElement>(null);

  const { logs, letters, jobStatus } = useJobLogs(jobId);

  useEffect(() => {
    logsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [logs]);

  const resetSelection = () => {
    setFile(null);
    setResult(null);
    setJobId(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const validateAndSetFile = (selected: File | undefined | null) => {
    if (!selected) return;
    if (!selected.name.toLowerCase().endsWith(".csv")) {
      toast.error("Please select a .csv file");
      return;
    }
    setFile(selected);
    setResult(null);
    setJobId(null);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    validateAndSetFile(e.target.files?.[0]);
  };

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    validateAndSetFile(e.dataTransfer.files?.[0]);
  }, []);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error("Please select a CSV file to upload.");
      return;
    }

    try {
      setLoading(true);
      setResult(null);
      setJobId(null);
      const response = await uploadPrincipalsPostingCsv(file);
      const flat = flattenResponseData(response);

      const newJobId = typeof flat.jobId === "string" || typeof flat.jobId === "number" ? String(flat.jobId) : null;
      const totalQueued = typeof flat.totalQueued === "number" ? flat.totalQueued : 0;
      const skipped = typeof flat.skipped === "number" ? flat.skipped : 0;
      const rowErrors = Array.isArray(flat.rowErrors) ? (flat.rowErrors as RowError[]) : [];

      setResult({ jobId: newJobId, totalQueued, skipped, rowErrors });
      setJobId(newJobId);

      if (totalQueued > 0) {
        toast.success(`${totalQueued} posting job(s) queued successfully`);
      } else {
        toast.warn("No valid records were queued. Check the errors below.");
      }
    } catch (error: unknown) {
      const apiError = error as { response?: { data?: { rowErrors?: RowError[]; MESSAGE?: string } } };
      const apiRowErrors = apiError?.response?.data?.rowErrors;
      const apiMessage = apiError?.response?.data?.MESSAGE;

      if (apiRowErrors?.length) {
        setResult({ jobId: null, totalQueued: 0, skipped: apiRowErrors.length, rowErrors: apiRowErrors });
      }

      toast.error(apiMessage ?? (error instanceof Error ? error.message : "Failed to upload CSV."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="max-w-5xl mx-auto pt-24 px-4 pb-12">
        <h2 className="text-2xl font-bold mb-6">Batch Post Principals & Vice Principals</h2>

        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onClick={() => fileInputRef.current?.click()}
          className={`border-2 border-dashed rounded-lg p-10 text-center cursor-pointer transition ${
            isDragging ? "border-indigo-500 bg-indigo-50" : "border-gray-300 bg-gray-50"
          }`}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            className="hidden"
          />
          {file ? (
            <p className="text-gray-800 font-medium">{file.name}</p>
          ) : (
            <p className="text-gray-500">Drag & drop a CSV file here, or click to select one</p>
          )}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={resetSelection}
            disabled={!file || loading}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 disabled:opacity-50"
          >
            Clear
          </button>
          <button
            onClick={handleUpload}
            disabled={!file || loading}
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2"
          >
            {loading ? <Loader /> : "Upload & Queue"}
          </button>
        </div>

        {result && (
          <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold">Live Log</h3>
                {jobId && (
                  <span
                    className={`text-xs px-2 py-1 rounded-full ${
                      jobStatus.status === "completed"
                        ? "bg-green-100 text-green-700"
                        : jobStatus.status === "failed"
                        ? "bg-red-100 text-red-700"
                        : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {jobStatus.status}
                  </span>
                )}
              </div>
              <div className="bg-black rounded-lg p-4 h-80 overflow-y-auto font-mono text-xs text-green-400 space-y-1">
                {logs.length === 0 ? (
                  <p className="text-gray-500">Waiting for job activity...</p>
                ) : (
                  logs.map((entry, idx) => (
                    <div key={idx}>
                      <span className="text-gray-500">
                        [{entry.timestamp ? new Date(entry.timestamp).toLocaleTimeString() : ""}]
                      </span>{" "}
                      {entry.message}
                    </div>
                  ))
                )}
                <div ref={logsEndRef} />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Generated Letters ({letters.length})</h3>
              <div className="border border-gray-200 rounded-lg h-80 overflow-y-auto divide-y">
                {letters.length === 0 ? (
                  <p className="text-gray-500 p-4">No letters generated yet.</p>
                ) : (
                  letters.map((letter, idx) => (
                    
                     <a key={idx}
                      href={letter.pdfUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between px-4 py-3 hover:bg-gray-50"
                    >
                      <div>
                        <p className="font-medium text-gray-800">{letter.role}</p>
                        <p className="text-sm text-gray-500">{letter.schoolName}</p>
                      </div>
                      <span className="text-indigo-600 text-sm">View PDF →</span>
                    </a>
                  ))
                )}
              </div>
            </div>
          </div>
        )}

        {result && (
          <div className="mt-8">
            <div className="flex gap-4 mb-4">
              <div className="flex-1 bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="text-sm text-green-700">Queued</p>
                <p className="text-2xl font-bold text-green-800">{result.totalQueued}</p>
              </div>
              <div className="flex-1 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-sm text-yellow-700">Skipped</p>
                <p className="text-2xl font-bold text-yellow-800">{result.skipped}</p>
              </div>
            </div>

            {result.rowErrors.length > 0 && (
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <table className="w-full text-left text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-2 w-20">Row</th>
                      <th className="px-4 py-2">Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {result.rowErrors.map((rowError, idx) => (
                      <tr key={`${rowError.row}-${idx}`} className="border-t border-gray-200">
                        <td className="px-4 py-2">{rowError.row}</td>
                        <td className="px-4 py-2 text-red-600">{rowError.reason}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};